import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { selectedCompanyId } from "../../lib/api";
import { useAuth } from "../../stores/auth";
import { canReturnToFinance, financeMonthLabel, financeReturnSearch, type FinanceOrigin } from "../../features/eex/finance-navigation";

export function FinanceReturnLink({ origin }: { origin: FinanceOrigin }) {
  const user = useAuth(state => state.user);
  const company = selectedCompanyId() ?? user?.companyId ?? null;
  if (!canReturnToFinance(origin, company)) return null;
  return <Link to="/eex/pnl" search={financeReturnSearch(origin)} className="inline-flex min-h-10 items-center gap-2 rounded-lg border border-border bg-bg px-3 py-2 text-sm font-medium text-accent hover:bg-accent/5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent">
    <ArrowLeft size={15} aria-hidden="true" />{origin.financeTab === "matrix" ? "Back to P&L by month" : `Back to ${financeMonthLabel(origin.financeMonth!)} Finance`}
  </Link>;
}
